import { Theme } from '@material-ui/core';
import { CSSProperties } from 'react';

export const getFirstBoxStyles = ({ spacing }: Theme): CSSProperties => ({
  marginBottom: spacing(1),
});

export const getSingleBarGraphStyle = ({ spacing }: Theme): CSSProperties => ({
  marginRight: spacing(3),
  marginBottom: 0,
});
